export const EscalatorRunning = ({ width = '25', height = '24' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 25 24"
  >
    <path
      fill="#363BC4"
      d="M7.606 5.817a1.816 1.816 0 0 1 3.104-1.285 1.816 1.816 0 0 1-1.286 3.102 1.82 1.82 0 0 1-1.818-1.817m1.236 14.174H6.88a2.546 2.546 0 0 1-2.546-2.544 2.543 2.543 0 0 1 2.546-2.544h.363v-4.361a2.18 2.18 0 0 1 2.182-2.18 2.18 2.18 0 0 1 2.182 2.18v.727l1.498-1.684a3.64 3.64 0 0 1 2.72-1.224h1.964a2.546 2.546 0 0 1 2.545 2.544 2.543 2.543 0 0 1-2.545 2.544h-1.164a.73.73 0 0 0-.544.245l-4.516 5.077a3.64 3.64 0 0 1-2.722 1.22m-.145-5.451 1.454-1.636v-2.362a.727.727 0 1 0-1.454 0zm-1.818 3.997h1.963a2.18 2.18 0 0 0 1.63-.732l4.517-5.078a2.18 2.18 0 0 1 1.635-.732h1.164a1.091 1.091 0 1 0 0-2.18h-1.964a2.18 2.18 0 0 0-1.63.732l-4.517 5.078a2.18 2.18 0 0 1-1.635.732H6.88a1.091 1.091 0 1 0 0 2.18m13.005-2.851a.7.7 0 0 0-.278-.056h-2.91a.727.727 0 1 0 0 1.454h1.154l-1.667 1.666a.727.727 0 1 0 1.028 1.028l1.668-1.667v1.153a.727.727 0 1 0 1.454 0v-2.907a.73.73 0 0 0-.45-.671"
    />
  </svg>
);
